/**
 * Process nav — barra chip sticky con scrollspy (pagina "Processo Produttivo").
 *
 * I chip (.process-nav__chip) sono ancore verso le fasi (#step-slug). Qui:
 *  - evidenziamo il chip della fase visibile (IntersectionObserver);
 *  - portiamo il chip attivo in vista nella barra scrollabile orizzontale;
 *  - smooth scroll al click (rispettando prefers-reduced-motion e lo
 *    scroll-margin-top che tiene conto delle barre sticky).
 */
(function () {
	'use strict';

	var nav = document.querySelector('.js-process-nav');
	if (!nav) {
		return;
	}

	var chips = Array.prototype.slice.call(nav.querySelectorAll('.process-nav__chip'));
	if (!chips.length) {
		return;
	}

	var scroller = nav.querySelector('.process-nav__scroller') || nav;
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function targetOf(chip) {
		var href = chip.getAttribute('href') || '';
		return href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
	}

	var steps = chips.map(targetOf).filter(Boolean);
	if (!steps.length) {
		return;
	}

	function centerChip(chip) {
		var offset = chip.offsetLeft - (scroller.clientWidth - chip.offsetWidth) / 2;
		if (typeof scroller.scrollTo === 'function') {
			scroller.scrollTo({ left: offset, behavior: reduceMotion ? 'auto' : 'smooth' });
		} else {
			scroller.scrollLeft = offset;
		}
	}

	function setActive(id) {
		chips.forEach(function (chip) {
			var active = chip.getAttribute('href') === '#' + id;
			chip.classList.toggle('is-active', active);
			if (active) {
				chip.setAttribute('aria-current', 'true');
				centerChip(chip);
			} else {
				chip.removeAttribute('aria-current');
			}
		});

		// Evidenzia anche l'icona della fase visibile nel rail sticky.
		steps.forEach(function (step) {
			var icon = step.querySelector('.process-step__icon');
			if (icon) {
				icon.classList.toggle('is-active', step.id === id);
			}
		});
	}

	// Scrollspy: la fascia attiva è centrata verticalmente sotto le barre sticky.
	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					setActive(entry.target.id);
				}
			});
		},
		{ rootMargin: '-45% 0px -50% 0px', threshold: 0 }
	);

	steps.forEach(function (step) {
		observer.observe(step);
	});

	// Smooth scroll al click (scrollIntoView rispetta scroll-margin-top).
	chips.forEach(function (chip) {
		chip.addEventListener('click', function (event) {
			var target = targetOf(chip);
			if (!target) {
				return;
			}
			event.preventDefault();
			target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
			setActive(target.id);
			if (window.history && window.history.replaceState) {
				window.history.replaceState(null, '', chip.getAttribute('href'));
			}
		});
	});
})();
